export default "__VITE_ASSET__8527d6e2__"